import { Component, Input } from '@angular/core';
import { DataRowComponent, DataTableComponent } from 'components/layout/data-table/data-table.component';
import { ViewSalesflowComponent } from 'components/task/salesflow/view-salesflow.component';
import { CompanyModel } from 'models/generated/Entities.GormCrm.Company';
import { BusinessDtoModel } from 'models/generated/Models.LeadsApi.BusinessDto';
import { Layout } from 'modules/layout';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';

@Component({
	selector: 'leads-single',
	templateUrl: './leads-single.component.html',
	imports: [ViewSalesflowComponent, Layout, DataTableComponent, DataRowComponent, TranslatePipe, CustomDatePipe]
})

export class LeadsSingleComponent {
	@Input() company?: CompanyModel;
	@Input() leadCompany?: BusinessDtoModel;

	constructor(private readonly translate: TranslatePipe) {
	}

	hasNumber(company: CompanyModel): Boolean {
		return company.companyContacts[0] && company.companyContacts[0].contact!.contactPhones[0] && company.companyContacts[0].contact!.contactPhones[0].number != undefined;
	}

	hasEmail(company: CompanyModel): Boolean {
		return company.companyContacts[0] && company.companyContacts[0].contact!.emailAddress != undefined;
	}

	getNumber(company: CompanyModel): string {
		if (company.companyContacts[0] && company.companyContacts[0].contact!.contactPhones[0] && company.companyContacts[0].contact!.contactPhones[0].number) return company.companyContacts[0].contact!.contactPhones[0].number;
		return this.translate.transform('general.na');
	}

	getEmail(company: CompanyModel): string {
		if (company.companyContacts[0] && company.companyContacts[0].contact!.emailAddress) return company.companyContacts[0].contact!.emailAddress;
		return this.translate.transform('general.na');
	}

	getAdaptedUrl(url: string): string {
		if (url.substr(0, 8) != 'https://' && url.substr(0, 7) != 'http://') url = 'https://' + url;
		if (url.substr(url.length - 1, 1) == '/') url = url.substr(0, url.length - 1);
		return url.toLowerCase();
	}
}
